import { Alert, AlertTitle, Divider, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDataProvider } from "react-admin";
import { SiteType } from "shared/types";
import { fetchR2ChroniclesGroupMasks } from "../querys";
import TableFormContainer from "./TableFormContainer";
import { IecConfigInfo, RampTestKey } from "../types";
import { isTestMasks } from "../utils";

interface JboxInputsTablesProps {
  formData: any;
  iecConfigInfo: IecConfigInfo;
}

const JboxInputsTables = ({ formData, iecConfigInfo }: JboxInputsTablesProps) => {
  const dataProvider = useDataProvider();
  const [error, setError] = useState<string>();
  const [sites, setSites] = useState<SiteType[]>([]);

  const { group_id, startingDate } = formData;

  const disabled = useMemo(() => {
    return !formData || !group_id || !startingDate;
  }, [formData, group_id, startingDate]);

  useEffect(() => {
    const fetchMasks = async () => {
      if (disabled) return;
      setError(undefined);
      try {
        const {
          masks,
          group: { sites },
        } = await fetchR2ChroniclesGroupMasks(startingDate, group_id, dataProvider);
        setSites(sites);
        if (!masks.length || !isTestMasks(masks)) {
          setError("All masks are not r2 chronicles masks.");
          return;
        }
        setError(undefined);
      } catch (error) {
        setError(`Error fetching masks: ${error}`);
      }
    };

    fetchMasks();
  }, [dataProvider, disabled, group_id, startingDate]);

  return (
    <>
      {error && !disabled && (
        <Alert severity="error" sx={{ width: "100%", mb: 3 }} variant="filled">
          <AlertTitle sx={{ fontWeight: "bold" }}>Warning</AlertTitle>
          <Typography variant="body2">{error}</Typography>
          <strong>This is non blocking. Make sure this was intended before proceeding, or update the masks.</strong>
        </Alert>
      )}

      <Divider />

      {!disabled && (
        <>
          <TableFormContainer
            rampTestKey={RampTestKey.RampTest1}
            formTitle="Test n° 1 (test de rampe avec niveau N passant de -1 à 1)"
            iecConfigInfo={iecConfigInfo}
            sites={sites}
          />

          <TableFormContainer
            rampTestKey={RampTestKey.RampTest2}
            formTitle="Test n° 2 (test de rampe avec niveau N passant de 1 à -1)"
            iecConfigInfo={iecConfigInfo}
            sites={sites}
          />
        </>
      )}
    </>
  );
};

export default JboxInputsTables;
